import { Links } from '@remix-run/react';

export type ErrorPageLayoutProps = {
  children: React.ReactNode;
};

export const ErrorPageLayout = ({ children }: ErrorPageLayoutProps) => {
  return (
    <>
      <Links />
      <main className="text-center pt-12 pb-12">{children}</main>
    </>
  );
};
